import React from 'react';

import COLORS from '../../../constants/colors.constants';

const StopIcon = ({
  className = '',
  width = 16,
  height = 16,
  rectWidth = 8,
  rectHeight = 8,
  fill = COLORS.brand,
}) => (
  <svg className={className} width={width} height={height} fill="none" viewBox="0 0 24 24">
    <path d="M12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2ZM3.875 12C3.875 14.1549 4.73102 16.2215 6.25476 17.7452C7.77849 19.269 9.84512 20.125 12 20.125C14.1549 20.125 16.2215 19.269 17.7452 17.7452C19.269 16.2215 20.125 14.1549 20.125 12C20.125 9.84512 19.269 7.77849 17.7452 6.25476C16.2215 4.73102 14.1549 3.875 12 3.875C9.84512 3.875 7.77849 4.73102 6.25476 6.25476C4.73102 7.77849 3.875 9.84512 3.875 12Z" fill={fill}/>
    <rect x="8" y="8" width={rectWidth} height={rectHeight} rx="1" fill={fill}/>
  </svg>
)

export default StopIcon;
